module.exports = '<div class="modal-close-button" ng-click="close()">\n    <i class="fa fa-times"></i>\n</div>\n<div id="media-player">\n</div>';